import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import xlsx from 'json-as-xlsx';
import downloadSvg from 'assets/icons/download.svg';
import { Asset } from 'components/common/types/Asset.types';
import { Store } from 'components/common/types/Store.types';
import Button, { Color, Size } from 'lib/Button';
import { getIsReseller } from 'store/publisher/selectors';
import { getDisplayCampaignId } from 'store/dealManagement/selectors/getDealId';
import { generateFrameListData, getFrameListSettings } from 'utils/frameList';

interface FrameListExportButtonProps {
  assets: Asset[];
}

export const FrameListExportButton = ({ assets }: FrameListExportButtonProps): React.ReactElement => {
  const { localeCode, currencyCode } = useSelector((state: Store) => state.publisher.configuration);
  const isReseller = useSelector(getIsReseller);
  const displayCampaignId = useSelector(getDisplayCampaignId);
  const dealName = useSelector((state: Store) => state.dealManagement.commonDeal.dealName);

  const generateDealData = useCallback(
    () =>
      generateFrameListData({
        assets,
        currencyCode,
        localeCode,
        conditionalColumns: {
          mediaOwner: !isReseller,
          frameCode: !isReseller,
          vioohId: !assets.some((asset) => asset.vioohId),
        },
      }),
    [assets, isReseller, currencyCode, localeCode],
  );

  const handleExportFrameList = (): Buffer | undefined =>
    xlsx(generateDealData(), getFrameListSettings({ dealId: displayCampaignId, campaignName: dealName }));

  return (
    <Button
      dataTestId="export-frames"
      classNames="ml-auto mr-4"
      isDisabled={!assets.length}
      svg={downloadSvg}
      label="Export list"
      size={Size.LARGE}
      color={Color.TERTIARY}
      onClick={handleExportFrameList}
    />
  );
};
